import { comparisonData } from "@/mocks/comparisonData";

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-xs ${i < count ? "ri-star-fill text-accent-500" : "ri-star-line text-foreground-300"} w-3.5 h-3.5 flex items-center justify-center`}
        ></i>
      ))}
    </div>
  );
}

export default function ComparisonSection() {
  return (
    <section className="bg-background-100/50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100/60 rounded-full text-xs font-semibold text-accent-800 mb-4 tracking-wider">
            COMPARISON
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Which Spreadsheet System Is Right for You?
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Compare the leading agent spreadsheet systems side by side to find your perfect match.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-background-200/60">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-background-100">
                <th className="px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Platform</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Spreadsheet Support</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Speed</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">QC Efficiency</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Beginner Friendly</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.platform} className={idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}>
                  <td className="px-6 py-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">{row.platform}</td>
                  <td className="px-6 py-4"><StarRating count={row.support} /></td>
                  <td className="px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">{row.speed}</td>
                  <td className="px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">{row.qcEfficiency}</td>
                  <td className="px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">{row.beginnerFriendly}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}